import React from 'react'
import { Form } from 'react-bootstrap'
import { withTranslation } from 'react-i18next'
import moment from 'moment'

const DoctorConfirmarCita = ({t, paciente, setCheckedTerms}) => {
    return (<div className='body'>
        <p className='section-title'>{t('confirmar_cita')}</p>
        <p className="font-size-08rem mb-0">
            Entendiendo que estoy obteniendo un servicio de tele orientación, para la realización de la valoración de signos, síntomas en particular y 
            que depende de mí seguir las recomendaciones médicas dadas y cuidados primarios y que en casos de persistir los signos o síntomas puedo comunicarme 
            para solicitar telemedicina o asistencia domiciliaria, según sea el caso. Si por el contrario presento signos de alarma que apliquen a mi caso y que el 
            profesional de salud me ha informado debo acudir a la red de urgencias relacionada en el Directorio Médico de
            <strong> {(paciente && paciente.account) && paciente.account.name}</strong>. para la atención medica de acuerdo con mi póliza.
        </p>
                
        <p className="font-size-08rem mb-0">
            Entiendo que <strong>KOM CARE IPS S.A.S Y Doctor Video</strong>, protegerá la confidencialidad de mi información médica y 
            personal de acuerdo con las normas que regulan la protección de datos y la prestación de servicios de salud. 
        </p>
        <p className="font-size-08rem mb-0">
            Entiendo que el propósito de esta modalidad de servicio es obtener una orientación con mayor oportunidad de atención, sin que ésta implique 
            desplazamiento a una Institución de Salud, por lo que no se realizarán procedimientos clínicos de mediana o alta complejidad, por el contrario, 
            se realizará la valoración sin generar riesgos y/o complicaciones a mi salud y en los casos que el profesional de salud considere que mi estado 
            clínico requiere una intervención médica más especializada y/o de urgencia, será informado y coordinado de acuerdo con el nivel de atención que yo requiera. 
        </p>
        <p className="font-size-08rem mb-0">
            Entiendo que la información resultante de esta consulta es parte de mi historia clínica, y que por lo tanto todos los registros que por ella se 
            ocasionen deberán ser adjuntados a ésta. 
        </p>
        <p className="font-size-08rem mb-0">
            Certifico que he leído o me han leído este documento y comprendo su contenido, así como que me han explicado los propósitos de esta modalidad de 
            atención médica y se me ha permitido realizar todas las preguntas, recibiendo la respuesta concisa y clara. 
        </p>
        <p className="font-size-08rem mb-0">
            Así mismo libero a la KOM CARE IPS S.A.S., de cualquier otra responsabilidad ajena a la prestación del servicio de tele orientación. 
        </p>
        {/* <p className="font-size-08rem mb-0">
            <strong>Fecha {moment(query.get('date'), 'DD-MM-YYYY').format('dddd DD MMMM YYYY')} {query.get('hour')} </strong>
        </p> */}
        <p className="font-size-08rem mb-0">
            Soy <strong>{paciente && `${paciente.name} ${paciente?.middleName ?? ''} ${paciente.lastName} ${paciente?.seccondSurname ?? ''}`}</strong> o su representante legal, he leído y acepto este consentimiento.
        </p>
        <div className="">
            <Form.Group className="text-center text-md-right">
                <Form.Check type="checkbox" 
                    label={t('acepto')} 
                    className="checked-terms" 
                    onChange={ e => setCheckedTerms(e.target.checked) } 
                />
            </Form.Group>
        </div>
    </div>)
}

export default withTranslation()(DoctorConfirmarCita)
